

// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import "./Register.css";
// import { API_URL } from "../services/api";

// const Register = () => {
//   const [fname, setName] = useState(""); // New state for the name field
//   const [lname, setLName] = useState("");
//   const [username, setUsername] = useState("");
//   const [email, setEmail] = useState("");
//   const [password1, setPassword1] = useState("");
//   const [password2, setPassword2] = useState("");
//   const [error, setError] = useState("");
//   const [message, setMessage] = useState("");
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     setError("");
//     setMessage("");

//     if (password1 !== password2) {
//       setError("Passwords do not match!");
//       return;
//     }

//     try {
//       const response = await axios.post(`${API_URL}register/`, {
//         fname,
//         lname, // Send the name field to the backend
//         username,
//         password1,
//         password2,
//         email,
//       });

//       // On success, show a success message
//       setMessage("User registered successfully!");

//       // Redirect to login page after successful registration
//       setTimeout(() => {
//         navigate("/login");
//       }, 2000); // Redirect after 2 seconds to allow the success message to be visible
//     } catch (err) {
//       // Handle registration errors
//       if (err.response && err.response.data) {
//         setError(err.response.data.error || "Registration failed!");
//       } else {
//         setError("Something went wrong!");
//       }
//     }
//   };

//   return (
//     <div className="register-container">
//       <h2 className="pageHeader">Register</h2>

//       {message && <p style={{ color: "green" }}>{message}</p>}
//       {error && <p style={{ color: "red" }}>{error}</p>}

//       <form onSubmit={handleSubmit} class="register-form">
//         <div className="register-firstname">
//           <label>First Name:</label>
//           <input
//             type="text"
//             value={fname}
//             onChange={(e) => setName(e.target.value)}
//             required
//           />
//         </div>

//         <div>
//           <label>Last Name:</label>
//           <input
//             type="text"
//             value={lname}
//             onChange={(e) => setLName(e.target.value)}
//             required
//           />
//         </div>

//         <div>
//           <label>Username:</label>
//           <input
//             type="text"
//             value={username}
//             onChange={(e) => setUsername(e.target.value)}
//             required
//           />
//         </div>

//         <div>
//           <label>Email:</label>
//           <input
//             type="email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             required
//           />
//         </div>

//         <div>
//           <label>Password:</label>
//           <input
//             type="password"
//             value={password1}
//             onChange={(e) => setPassword1(e.target.value)}
//             required
//           />
//         </div>

//         <div>
//           <label>Confirm Password:</label>
//           <input
//             type="password"
//             value={password2}
//             onChange={(e) => setPassword2(e.target.value)}
//             required
//           />
//         </div>

//         <div className="register-but">
//           <button className="signIn-but" type="submit">
//             Register
//           </button>
//         </div>
//         {/* <button type="submit">Register</button> */}
//       </form>
//     </div>
//   );
// };

// export default Register;


import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Register.css";
import { API_URL } from "../services/api";

const Register = () => {
  const [fname, setName] = useState(""); // New state for the name field
  const [lname, setLName] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    setMessage("");

    if (password1 !== password2) {
      setError("Passwords do not match!");
      return;
    }

    try {
      const response = await axios.post(`${API_URL}register/`, {
        fname,
        lname, // Send the name field to the backend
        username,
        password1,
        password2,
        email,
      });

      // On success, show a success message
      setMessage("User registered successfully!");

      // Redirect to login page after successful registration
      setTimeout(() => {
        navigate("/login");
      }, 2000); // Redirect after 2 seconds to allow the success message to be visible
    } catch (err) {
      // Handle registration errors
      if (err.response && err.response.data) {
        setError(err.response.data.error || "Registration failed!");
      } else {
        setError("Something went wrong!");
      }
    }
  };

  return (
    <div className="register-container">
      <div className="register-card">
        <div className="register-header">
          <h2 className="pageHeader">Join Verdure!</h2>
          <p className="register-subtitle">Create your account to get started!</p>
        </div>

        {message && <p style={{ color: "green" }}>{message}</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}

        <form onSubmit={handleSubmit} className="register-form">
          <div className="name-row">
            <div className="register-firstname">
              <label>First Name</label>
              <input
                type="text"
                value={fname}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter your first name"
                required
              />
            </div>

            <div>
              <label>Last Name</label>
              <input
                type="text"
                value={lname}
                onChange={(e) => setLName(e.target.value)}
                placeholder="Enter your last name"
                required
              />
            </div>
          </div>

          <div>
            <label>Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Choose a unique username"
              required
            />
          </div>

          <div>
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your.email@example.com"
              required
            />
          </div>

          <div>
            <label>Password</label>
            <input
              type="password"
              value={password1}
              onChange={(e) => setPassword1(e.target.value)}
              placeholder="Create a secure password"
              required
            />
          </div>

          <div>
            <label>Confirm Password</label>
            <input
              type="password"
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
              placeholder="Confirm your password"
              required
            />
          </div>

          <div className="register-but">
            <button className="signIn-but" type="submit">
              Create Account
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Register;